<template>
  <div class="terms" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>ナイミー利用規約</h1>
    <p>「ナイミー 利用規約」（以下、「本規約」といいます。）は、メノア株式会社（以下、「当社」といいます。）が提供するアプリ「ナイミー（nimee）」（以下、「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用するお客様（以下、「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。</p>

    <h2>第1条 適用</h2>
    <p>本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</p>

    <h2>第2条 契約の成立</h2>
    <p>ユーザーが本サービスをスマートフォンやその他の情報端末にダウンロードした時点で本規約に同意したものとみなし、当社とユーザーとの間で本サービスの提供にかかる契約（以下、「本契約」といいます。）が成立します。</p>

    <h2>第3条 本規約の変更</h2>
    <ul>
      <li>当社は、必要に応じて本規約の内容を変更することができるものとします。変更後の規約は、本サービス上または当社のウェブサイトへの掲載により告知します。</li>
      <li>ユーザーが本規約の変更後も本サービスの利用を継続する場合、変更後の規約に同意したものとみなされます。</li>
    </ul>

    <h2>第4条 利用資格</h2>
    <ul>
      <li>本サービスは、性生活に関わる内容を取り扱うため、18歳以上の方を対象としています。18歳未満の方は本サービスを利用することができません。</li>
      <li>ユーザーは、本サービスを利用した時点で、自身が18歳以上であることを表明し、保証するものとします。</li>
    </ul>

    <h2>第5条 本サービスの内容</h2>
    <ul>
      <li>本サービスは、夫婦・カップル（以下「パートナー」といいます。）の間で、夜の誘い・応答に関する気持ちや温度感を共有するためのアプリです。</li>
      <li>本サービスの一部機能の利用には、ユーザー間でのパートナー連携が必要です。</li>
      <li>ユーザーが入力した誘い・応答の内容は、本サービスを通じて連携したパートナーに共有されます。当該内容を含むデータは、サービス提供のため当社の利用するサーバーに保存されます。</li>
      <li>本サービスは、機種変更等に備えてデータ引き継ぎの準備およびデータ復元を行う機能を提供する場合があります。当該機能を利用するには、当社所定の方法によりAppleまたはGoogleのアカウントを連携する必要があります。</li>
      <li>本サービスは、ユーザーが私的に使用する目的でのみ利用することができます。</li>
      <li>当社は、ユーザーに通知することなく、本サービスの内容を変更し、または本サービスの提供を中止することができるものとします。</li>
    </ul>

    <h2>第6条 パートナー連携</h2>
    <ul>
      <li>パートナー連携は、本サービス上で表示されるQRコードを相互に読み取る等の方法により行います。</li>
      <li>ユーザーは、相手方の同意を得たうえでパートナー連携を行うものとし、相手方の意思に反して連携を行ってはなりません。</li>
      <li>ユーザーは、いつでもパートナー連携を解除することができます。</li>
    </ul>

    <h2>第7条 利用料金</h2>
    <ul>
      <li>本サービスは無料で利用できる機能と、定額料金制の有料機能（以下「プレミアム」といいます。）を提供する場合があります。プレミアムの料金、期間、内容その他の条件は、購入手続きの画面または本サービス上に表示します。</li>
      <li>無料で利用できる範囲は、当社が別途定める条件に従います。現在、本サービスでは、ユーザーが誘った側として相手から応答を受信した回数を基準に、所定回数まで無料で利用できます。無料で利用できる範囲を超えた場合、応答の送受信または閲覧が保留され、プレミアムへの登録が必要になることがあります。</li>
      <li>プレミアムに登録したユーザーがパートナー連携をしている場合、当社所定の条件に従い、連携中のパートナーもプレミアムの対象機能を利用できる場合があります。パートナー連携の解除、アカウントの削除、サブスクリプションの失効、技術的な制約その他の事情により、パートナーへの反映に時間を要し、または利用できなくなることがあります。</li>
      <li>プレミアムは自動更新サブスクリプションとして提供される場合があります。自動更新の停止、解約、返金その他の購入管理は、ユーザーが利用したApp Store・Google Play等のプラットフォームが定める方法に従って行うものとします。</li>
      <li>利用料金は、当社の定める手続きまたは各プラットフォームの手続きにより変更される場合があります。変更後の料金および適用時期は、購入手続きの画面、各プラットフォームからの通知、本サービス上の表示その他当社所定の方法により案内します。</li>
      <li>利用料金は、App Store・Google Play等のプラットフォームを通じてお支払いいただきます。なお、支払に要する通信料その他の費用は、ユーザーの負担とします。</li>
      <li>利用料金の支払い、解約、返金その他の購入に関し、ユーザーとApp Store・Google Play等のプラットフォームとの間で紛争が生じた場合は、ユーザーの責任と費用負担においてこれを解決していただくものとし、当社は当社の故意または重過失がある場合を除き責任を負わないものとします。</li>
    </ul>

    <h2>第8条 禁止事項</h2>
    <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
    <ul>
      <li>法令または公序良俗に違反する行為</li>
      <li>相手方の同意を得ずに本サービスを利用する行為、および本サービスを嫌がらせ、強要、ハラスメントその他相手方の意思を不当に害する目的で利用する行為</li>
      <li>他人になりすます行為、または不正にパートナー連携を行う行為</li>
      <li>本サービスの運営を妨害する行為</li>
      <li>本サービスのリバースエンジニアリングその他ソースコードを解析する行為</li>
      <li>その他、当社が不適切と判断する行為</li>
    </ul>

    <h2>第9条 著作権</h2>
    <p>本サービスにより提供されるコンテンツ、サービス、技術などの情報は、著作権等の知的財産権関連法令で保護されています。ユーザーは、当該情報を私的利用の範囲内でのみ利用できます。</p>

    <h2>第10条 免責事項</h2>
    <ul>
      <li>本サービスは、パートナー間のコミュニケーションを支援するものであり、当社は、ユーザーとパートナーとの関係や本サービスの利用の結果について、一切の責任を負いません。</li>
      <li>当社は、本サービスにより提供する情報の完全性、正確性、有用性等を保証するものではありません。</li>
      <li>本サービスの利用により生じた損害について、当社は一切の責任を負いません。</li>
      <li>データ復元機能は、ユーザーが事前に連携したAppleまたはGoogleのアカウントで認証できる場合に利用できます。アカウント連携が未設定の場合、認証できない場合、アカウントまたはデータが削除済みの場合、通信環境その他の技術的制約がある場合には、データを復元できないことがあります。</li>
      <li>当社は、データ引き継ぎの準備およびデータ復元機能を提供しますが、すべてのデータの保存、復元または完全性を保証するものではありません。</li>
      <li>プレミアムの購入状態、購入の復元、パートナーへの反映は、App Store・Google Play等のプラットフォーム、RevenueCatその他の外部サービス、通信環境および当社システムの状態により、反映に時間を要し、または一時的に正しく表示されない場合があります。</li>
    </ul>

    <h2>第11条 本サービスの利用終了</h2>
    <p>ユーザーは、パートナー連携を解除し、または本サービスをアンインストールすることで、いつでも本サービスの利用を終了することができます。</p>

    <h2>第12条 準拠法・裁判管轄</h2>
    <ul>
      <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
      <li>本サービスに関して紛争が生じた場合には、東京地方裁判所または東京簡易裁判所を専属的合意管轄とします。</li>
    </ul>

    <p>2026年6月5日制定<br>2026年6月23日改定</p>
  </div>
</template>

<script>
export default {
  name: 'NimeeTermsView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = '利用規約 | ナイミー';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

h2 {
  font-size: 20px;
  color: var(--color-grey-500);
  margin-top: 32px;
}

p, li {
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 16px;
}

.mobile p, .mobile li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.mobile ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.mobile li {
  margin-bottom: 5px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 24px;
  text-align: left;
}

.desktop h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 24px;
}

.desktop p, .desktop li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.desktop ul {
  margin-bottom: 20px;
  padding-left: 20px;
}

.desktop li {
  margin-bottom: 8px;
}
</style>
